// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close":"close-button__close--1gF1R"};